import { render, staticRenderFns } from "./WorkspaceEdgeActionMenu.vue?vue&type=template&id=38bc6e44&scoped=true"
import script from "./WorkspaceEdgeActionMenu.vue?vue&type=script&lang=js"
export * from "./WorkspaceEdgeActionMenu.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceEdgeActionMenu.vue?vue&type=style&index=0&id=38bc6e44&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bc6e44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38bc6e44')) {
      api.createRecord('38bc6e44', component.options)
    } else {
      api.reload('38bc6e44', component.options)
    }
    module.hot.accept("./WorkspaceEdgeActionMenu.vue?vue&type=template&id=38bc6e44&scoped=true", function () {
      api.rerender('38bc6e44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceEdgeActionMenu.vue"
export default component.exports